import styled, { css } from "styled-components";
import { colorMixin, typographyMixin } from "../../../helpers";

export const InputLike = styled.label<{
    $error: boolean;
    $disabled: boolean;
}>`
    --input-like-border-width: 1px;

    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    box-sizing: border-box;
    width: 100%;

    background: ${colorMixin("background-primary-base")};
    border-radius: 4px;
    border: var(--input-like-border-width) solid ${colorMixin("border-primary-100")};

    ${({ $disabled }) =>
        $disabled
            ? css`
                  background: ${colorMixin("background-primary-50")};
              `
            : css`
                  :hover {
                      border-color: ${colorMixin("border-primary-200")};
                  }

                  :focus-within,
                  &[data-focused="true"] {
                      border-color: ${colorMixin("border-primary-300")};
                      box-shadow: 0 1px 2px rgba(83, 86, 88, 0.24), 0 0 1px rgba(83, 86, 88, 0.16),
                          0 0 0 4px ${colorMixin("border-primary-100")};
                  }
              `};

    ${({ $error }) =>
        $error &&
        css`
            border-color: ${colorMixin("error-500")};

            :hover {
                border-color: ${colorMixin("error-800")};
            }

            :focus-within,
            &[data-focused="true"] {
                border-color: ${colorMixin("error-800")};
                box-shadow: 0 1px 2px rgba(83, 86, 88, 0.24), 0 0 1px rgba(83, 86, 88, 0.16),
                    0 0 0 4px ${colorMixin("error-100")};
            }
        `};

    textarea,
    input {
        padding: 0;
        border: none;
        background: transparent;
        width: 100%;

        ${typographyMixin("label-small-regular")}
        color: ${colorMixin("text-primary-1200")};

        ::placeholder {
            color: ${colorMixin("text-primary-500")};
        }

        :focus {
            outline: none;
        }

        :disabled {
            color: ${colorMixin("text-primary-500")};
        }
    }
`;

export const IconWrapper = styled.div`
    color: ${colorMixin("text-primary-400")};

    svg {
        display: block;
        height: 15px;
        width: 15px;
    }
`;
